import React from "react"
import { Link } from "gatsby"

export default class DemoFooter extends React.Component {
  render() {
    return (
      <div className={"row mt-5"} style={{ backgroundColor: "#fff" }}>
        <div className={"col-12 text-center p-5 text-primary"}>
          <h2
            style={{
              fontFamily: "Anton",
              fontSize: "3rem",
            }}
            className={"my-3 d-none d-md-block"}
          >
            POWERSPORTS BUSINESSES LARGE AND SMALL SAVE THOUSANDS OF DOLLARS EACH MONTH BY ELIMINATING WASTED PAYROLL, MAP VIOLATIONS AND, PAYMENTS TO THIRD-PARTY DEVELOPERS.
          </h2>
          <h3 className={"my-3"}>SCHEDULE A 15-MINUTE DEMO TODAY!</h3>
          <Link to={"/demo-request"} className={"btn btn-lg btn-secondary my-5"}>REQUEST A DEMO!</Link>
        </div>
      </div>
    )
  }
}
